// eslint-disable-next-line no-shadow
enum EOperatingSystem {
    Android = 'Android',
    iOS = 'iOS',
    Other = '',
}

export default EOperatingSystem
